import React, { FC } from 'react';

import { ICardItem } from '~/src/features/movix-new/Card';

import * as ST from './styled';

export interface ICardBenefits extends ICardItem {
    bgPosition?: string,
    textAlign: string,
    orderMobile: number,
    bgSizeMobile?: string,
    bgSize?: string,
}

interface IProps {
    data: ICardBenefits,
}

const BenefitsCard: FC<IProps> = ({ data }) => {

    return (
        <ST.Wrapper
            path={data.img}
            bgPosition={data.bgPosition}
            textAlign={data.textAlign}
            order={data.orderMobile}
            bgSizeMobile={data.bgSizeMobile}
            bgSize={data.bgSize}
        >
            <ST.TitleCard>
                {data.title}
            </ST.TitleCard>
            <ST.Text>
                {data.description}
            </ST.Text>
        </ST.Wrapper>
    );
};

export default BenefitsCard;
